import { Routes, Route, Navigate, useSearchParams, useLocation } from 'react-router-dom'
import { AuthRoutes, MainRoutes } from './Routes'
import { pathes } from './pathes'
import { getRefreshToken } from '@/shahrzad-assets/shared-constants/localstorage'
import { Suspense, useMemo } from 'react'
import CustomLoading from '@/shahrzad-assets/shared_components/CustomLoading'
import { SharedRoutes } from '@/shahrzad-assets/shared-routing/Routes'
import { pathes as driverPathes } from '@/modules/driver-pwa/routing/pathes'

const BaseRoutes = () => {
  const routeIsDriverPwa = window.location.pathname.includes(
    driverPathes.BASE_PATH,
  )
  const [searchParams, setSearchParams] = useSearchParams()
  const { pathname } = useLocation();
  const tokenFromApp = searchParams.get('token')
  const redirectPath = routeIsDriverPwa
    ? driverPathes.BASE_PATH + driverPathes.LOGIN
    : pathes.LOGIN_PHONE_NUMBER
  const routeIsAuthRoutes = () => {
    if (tokenFromApp) return true;
    
    if (redirectPath === pathname) return true;
    const authPathes = AuthRoutes.map(route => route.path)
    if (authPathes.includes(pathname)) return true;
    return false;
  }
  const GuestUserRoutes = () => {
    if (routeIsAuthRoutes()) return;
      return (
      <Routes>
        <Route
          path='*'
          element={
            <Suspense fallback={<CustomLoading />}>
              <Navigate to={redirectPath}></Navigate>
            </Suspense>
          }
        />
      </Routes>
    )
  }
  return (
    <Routes>
      {SharedRoutes.map((route, index) => {
        return route.layout ? (
          <Route
            key={index}
            path={route.path}
            element={
              <Suspense fallback={<CustomLoading />}>
                <route.layout {...route}>
                  <route.component />
                </route.layout>
              </Suspense>
            }
          ></Route>
        ) : (
          <Route
            key={index}
            path={route.path}
            element={<route.component />}
          ></Route>
        )
      })}

      {getRefreshToken() === null ? (
        <Route path='*' element={<GuestUserRoutes />} />
      ) : (
        MainRoutes.map((route, index) => {
          return route.layout ? (
            <Route
              key={index}
              path={route.path}
              element={
                <Suspense fallback={<CustomLoading />}>
                  <route.layout {...route}>
                    <route.component />
                  </route.layout>
                </Suspense>
              }
            ></Route>
          ) : (
            <Route
              key={index}
              path={route.path}
              element={
                <Suspense fallback={<CustomLoading />}>
                  <route.component />
                </Suspense>
              }
            ></Route>
          )
        })
      )}
    </Routes>
  )
}

export default BaseRoutes
